//REALM ROLES
export const ROLE_MANAGE_USER = 'user_management_view_menu';
export const REALM_ROLE_QUERY_GROUPS = 'query-groups';
export const REALM_ROLE_QUERY_USERS = 'query-users';
export const REALM_ROLE_VIEW_USERS = 'view-users';

//ORGANIZATION
export const ORGANIZATION_VIEW = 'organization_view';
export const ORGANIZATION_CREATE = 'organization_create';
export const ORGANIZATION_UPDATE = 'organization_update';
export const ORGANIZATION_DELETE = 'organization_delete';

//USER
// export const USER_VIEW = 'user_view';
export const USER_VIEW = 'user_management_user_view';
export const USER_PASSWORD = 'user_management_set_user_password';
export const USER_CREATE = 'user_management_user_create';
export const USER_UPDATE = 'user_management_user_update';
export const USER_DELETE = 'user_management_user_delete';

//USER BULK
export const USER_BULK_VIEW = 'user_bulk_view';
export const USER_BULK_CREATE = 'user_bulk_create';

//GEOGRAPHIC_LEVEL
export const GEOGRAPHIC_LEVEL_VIEW = 'geographic_level_view';
export const GEOGRAPHIC_LEVEL_CREATE = 'geographic_level_create';
export const GEOGRAPHIC_LEVEL_UPDATE = 'geographic_level_update';
export const GEOGRAPHIC_LEVEL_DELETE = 'geographic_level_delete';

//LOCATION HIERARCHY
export const LOCATION_HIERARCHY_VIEW = 'location_hierarchy_view';
export const LOCATION_HIERARCHY_CREATE = 'location_hierarchy_create';
export const LOCATION_HIERARCHY_DELETE = 'location_hierarchy_delete';

//LOCATION
export const LOCATION_VIEW = 'location_view';
export const LOCATION_CREATE = 'location_create';
export const LOCATION_UPDATE = 'location_update';
export const LOCATION_DELETE = 'location_delete';

//PLAN
export const PLAN_VIEW = 'plan_view';
export const PLAN_MANAGEMENT = 'plan_manage';
export const PLAN_CREATE = 'plan_create';
export const PLAN_UPDATE = 'plan_update';
export const PLAN_DELETE = 'plan_delete';
export const PLAN_ACTIVATE = 'plan_activate';

//REPORTS
export const REPORT_VIEW = 'report_view';
export const AMDR_REPORT_VIEW = 'view_amdr_report';

//ASSIGN
export const ASSIGNMENT_VIEW = 'assignment_plan';
export const ASSIGNMENT_CREATE = 'assignment_create';
export const ASSIGNMENT_UPDATE = 'assignment_update';
export const ASSIGNMENT_DELETE = 'assignment_delete';

//ADMIN
export const REVEAL_MANAGE = 'reveal_manage';

//ADMIN
export const REVEAL_SIMULATION = 'reveal_simulation_view';
export const REVEAL_SIMULATION_EDIT = 'reveal_simulation_edit';

//METADATA IMPORT
export const METADATA_FILE_IMPORT = 'metadata_file_import';

//METADATA IMPORT
export const TAG_ACCESS_OVERRIDE = 'tag_access_override';
export const TAG_MANAGEMENT_VIEW = 'tag_menu_view';
export const METADATA_IMPORT_VIEW = 'metadata_menu_view';

//HOME PAGE
export const MENU_HOME_VIEW = 'menu_home_view';

//INSTANCE
export const INSTANE_MANAGEMENT_VIEW = 'instance_management_view';
export const INSTANE_MANAGEMENT_CREATE = 'instance_management_create';
export const INSTANE_MANAGEMENT_EDIT = 'instance_management_edit';
export const INSTANE_MANAGEMENT_DELETE = 'instance_management_delete';

//GROUP CONFIGURATION
export const GROUP_MANAGEMENT_VIEW = 'group_management_view';
export const GROUP_MANAGEMENT_CREATE = 'group_management_create';
export const GROUP_MANAGEMENT_EDIT = 'group_management_edit';
export const GROUP_MANAGEMENT_DELETE = 'group_management_delete';
export const GROUP_MANAGEMENT_ADD_DATASET = 'group_management_add_dataset'
//
export const CAMPAIGN_MANAGEMENT = 'campaign_management_view';
export const ASSIGNMENT_PLAN = 'assignment_plan';

export const REVEAL_SIMULATION_USER = 'reveal_plan_simulation_view';

export const PLAN_LOCATION_ASSIGNMENT = 'plan_location_assignment';
export const PLAN_TEAM_ASSIGNMENT = 'plan_team_assignment';
export const PLAN_ASSIGNMENT_SUMMARY = 'plan_assignment_summary';

export const SIMULATION_ADD_DATASET = 'simulation_add_dataset';
export const SIMULATION_DELETE_ALL_DATASET = 'simulation_delete_all_dataset';
export const SIMULATION_DATASET_MENU = 'simulation_dataset_menu';
export const SIMULATION_HIDE_ALL_DATASET = 'simulation_hide_all_dataset';

export const CAMPAIGN_MANAGEMENT_ADD_TO_CAMPAIGN = 'campaign_management_add_to_campaign';
export const CAMPAIGN_MANAGEMENT_REMOVE_FROM_CAMPAIGN = 'campaign_management_remove_from_campaign';
export const CAMPAIGN_MANAGEMENT_ASSIGN_TO_TEAM = 'campaign_management_assign_to_team';

export const LOCATION_BULK_IMPORT = 'location_bulk_import';
export const LOCATION_VALIDATE_IMPORT = 'location_validate_import';

export const SIMPLE_TAG_CREATE = 'simple_tag_create';
export const COMPLEX_TAG_CREATE = 'complex_tag_create';
export const COMPLEX_TAG_VIEW_VARIABLES = 'complex_tag_view_variables';

export const METADATA_FILE_IMPORT_REMOVE_ACCESS = 'metadata_file_import_remove_access';
export const METADATA_FILE_IMPORT_GRANT_ACCESS = 'metadata_file_import_grant_access';
export const METADATA_FILE_IMPORT_UPLOAD_FILE = 'metadata_file_import_upload_file';

export const CAMPAIGN_MANAGEMENT_INSTANCE_SELECTION = 'campaign_management_instance_selection';
export const SIMULATION_INSTANCE_SELECTION = 'simulation_instance_selection'

export const PLAN_ASSIGNMENT_INSTANCE_SELECTION = 'plan_assignment_instance_selection'

export const USER_MANAGEMENT_ADD_USER_TO_INSTANE = 'user_management_add_user_to_instance';

export const USER_MANAGEMENT_ADD_GLOBAL_ADMIN = 'user_management_add_global_admin'
export const INSTANCE_USER_MANAGEMENT = 'instance_user_managment'

export const ACTIVATE_INSTANCE_PLAN = 'activate_instance_plan'
export const ACTIVATE_ADMIN_INSTANCE_PLAN = 'activate_admin_instance_plan'
export const REDIRECT_TO_ASSIGNED_INSTANCE = 'redirect_to_assigned_instance'

export const REDIRECT_TO_ASSIGNED_CAMPAIGN = 'redirect_to_assigned_campaign'
export const REDIRECT_TO_ASSIGNED_PLAN_SIMULATION = 'redirect_to_assigned_plan_simulation'

export const DATA_EXTRACT_VIEW = 'data_extracts_view'
export const REDIRECT_TO_INDIVIDUAL_INSTANCE_REPORT = "redirect_to_individual_instance_report"
